import { createSlice } from "@reduxjs/toolkit";

export const canvaSlice = createSlice({
  name: "canva",
  initialState: {
    isFetched: false,
    isLoading: false,
    designs: [],
    page: 1,
    hasMore: true
  },
  reducers: {
    onCallCanvaDesigns: (state) => {
      state.isLoading = true;
      state.designs = [];
    },
    onSuccessCanvaDesigns: (state, { payload }) => {
      if (payload.data?.items && payload.data?.items.length > 0) {
        state.designs = [
          ...state.designs.reduce((acc, existing) => {
            if (!payload.data.items.some((item) => item.id === existing.id)) {
              acc.push(existing);
            }
            return acc;
          }, []),
          ...payload.data.items
        ];
        state.page = payload.page + 1;
        state.hasMore = !(payload.data.items.length < 10);
      } else {
        state.hasMore = false;
      }
      state.isFetched = true;
      state.isLoading = false;
    },
    onFailedCanvaDesigns: (state) => {
      state.isFetched = true;
      state.isLoading = false;
    },
    resetCanvaDesigns: (state) => {
      state.isFetched = false;
      state.isLoading = false;
      state.designs = [];
      state.page = 1;
      state.hasMore = true;
    }
  }
});

export const { onCallCanvaDesigns, onSuccessCanvaDesigns, onFailedCanvaDesigns, resetCanvaDesigns } =
  canvaSlice.actions;

export default canvaSlice.reducer;
